import { AppState } from "./../types";
import { useSelector } from "react-redux";

export const useDefaultHosData = () => {
  return useSelector((state: AppState) => state.defaultHosData);
};
